function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "12.01 10.18 6.79 10.18 12.01 21.92 12.18 22.3 17.57 10.18 12.01 10.18",
    style: {
      fill: "#efeff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,9.15A.59.59,0,0,0,23.94,9L18.83,1.13l-.06-.07a.43.43,0,0,0-.32-.14H14.8l3.88,8.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.87,1.35l-.1-.21,0-.09a.53.53,0,0,1,0-.13h-3.1a.53.53,0,0,1,0,.13l0,.09-.27.57L6.81,9.15H17.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13,1.13.08,9A.71.71,0,0,0,0,9.19s.05,0,.08,0h5.6L9.56.92H5.42A.53.53,0,0,0,5.13,1.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.17,10.18H.12a.56.56,0,0,1,.05.08L11.4,23.08,5.67,10.18Z",
    style: {
      fill: "#f9f9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.26,22.42,23.85,10.25l0-.07H18.69Z",
    style: {
      fill: "#efeff0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingActive);
export default __webpack_public_path__ + "static/media/pricing-active.cd0759d3f4ef007ef96a3eabbed65714.svg";
export { ForwardRef as ReactComponent };